var render = function render(_c,_vm){return _c('a',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"href":`tel:${_vm.props.number}`,"title":_vm.props.number}},[(!_vm.children)?[_vm._v(" "+_vm._s(_vm.props.number)+" ")]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }